/**
 * Onboarding-Gesundheit einer Person (0–100).
 *
 * Lag bis zum 08.10.2026 im Onboarding-Fenster selbst und war dadurch nicht
 * prüfbar. Ohne React, damit die Regel testbar ist.
 *
 * Event-Teilnahme zählt seit dem 08.10.2026 hier nicht mehr mit (Marie 16.09.2026:
 * „weil sie ja gerade erst gestartet sind"). Sie zählt weder als eigener Abzug noch
 * über die beiden Event-Signale in der Signalliste. Ganz heraus ist sie damit nicht:
 * Der Risiko-Score des Servers (`retentionScore`, der erste Abzug unten) enthält die
 * beiden Event-Signale weiter (Standardgewichte 0,09 und 0,07, siehe
 * `src/services/retention-scoring.ts`), und dieser Score geht hier ein.
 */
import type { EmployeeAnalysis } from "./api.js";
import { onboardingAbzugKrankheit } from "./krankheitstage.js";

/** Signale, die im Onboarding nichts über die Bindung sagen. */
const OHNE_WERTUNG = new Set(["low_event_participation", "no_recent_event"]);

export function onboardingGesundheit(a: EmployeeAnalysis): number {
  let score = 100;
  if (a.retentionScore > 0.7) score -= 30;
  else if (a.retentionScore > 0.45) score -= 15;

  // Eigene Krankheitstage in 3 Monaten (Arbeitstage, ohne „Kind krank")
  score -= onboardingAbzugKrankheit(a.sickDayStats?.sickDays3m ?? 0);

  // Nur Risiko-Signale abziehen — positive Anker senken die Gesundheit nicht.
  const risiko = a.signals.filter((s) => s.triggered && !s.positive && !OHNE_WERTUNG.has(s.key));
  score -= risiko.length * 5;

  return Math.max(0, Math.min(100, score));
}
